import React, {  useState } from "react";
import {  useNavigate } from "react-router-dom";

import { getTrans as t } from "../../../Localization/translations";
import Helper from "../../../Helper";

function InvoicesDue({ invoice }) {
  const [permissionss, setPermission] = useState(
    localStorage.getItem("permissions")
  );
  const permissionsArray = permissionss.split(",");

  let navigate = useNavigate();

  const handleView = (id) => {
    navigate("/billing/viewinvoices", { state: id });
  };

  return (
    <>
        <div className="">
          <div className="card-body px-0 pb-2">
            <div className="table-responsive">
              <table className="table table-striped align-items-center mb-0">
                <thead>
                  <tr>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("INVOICE NUMBER")}
                    </th>
                    <th className="text-uppercase  text-left text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("CUSTOMER NAME")}
                    </th>
                    <th className="text-uppercase text-left text-secondary text-xxs font-weight-bolder opacity-7 ps-2">
                      {t("CONTRACT NUMBER")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("AMOUNT DUE")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("PAST DUE DAYS")}
                    </th>
                    <th className="text-left text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      {t("DUE DATE")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {invoice.map((key) => (
                    <tr>
                      <td className="align-middle text-left ">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("INVOICE NUMBER")}
                          </div>
                          <div
                            className="hyperlink"
                            onClick={() =>permissionss && permissionsArray.includes('view_invoiceheader')===true ? handleView(key.id):""}
                          >
                            {key.invoice_number}
                          </div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("CUSTOMER NAME")}
                          </div>
                          <div>{key.customer_name}</div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("CONTRACT NUMBER")}
                          </div>
                          <div>{key.contract_id.contract_number}</div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("AMOUNT DUE")} </div>
                          <div>{Helper.Amount(key.balance_amount)}</div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">
                            {t("PAST DUE DAYS")}
                          </div>
                          <div>{Helper.DueDays(key.due_date)}</div>
                        </>
                      </td>
                      <td className="align-middle text-left">
                        <>
                          <div className="d-xl-none tc d-md-none d-lg-none">{t("DUE DATE")} </div>
                          <div>{Helper.DateNormal(key.due_date)}</div>
                        </>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
    </>
  );
}

export default InvoicesDue;
